<template>
  <v-row>
    <v-col cols="12">
      <h4>{{title}}</h4>
      <v-divider class="mb-4"></v-divider>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props:{
    title:{
      type: String
    }
  },
  name: "title.vue"
}
</script>

<style scoped>

</style>
